import z from 'zod';

export const InventoryTotalsSchema = z.object({
    tenantInventoryId: z.string(),
    quantityAllocated: z.number(),
    quantityOnHand: z.number(),
});

export type InventoryTotals = z.infer<typeof InventoryTotalsSchema>;
